export const CONTACT_NAV_URL = "https://www.nav.no/kontaktoss#skriv-til-oss";
